import { Injectable, Signal } from '@angular/core';
import { Observable } from 'rxjs';
import { TargetInfo } from './target-device-info';

export type ConnState = 'disconnected' | 'connecting' | 'connected' | 'disconnecting';

export type ConnTargetState = ConnState | 'awaitingDevice';

@Injectable()
export abstract class ConnectionManager {
    abstract errorNotification: Observable<any>;
    abstract connState: ConnState;
    abstract connStateObs: Observable<ConnState>;
    abstract connTargetState: ConnTargetState;
    abstract connTargetStateObs: Observable<ConnTargetState>;
    abstract connectionStateSignal: Signal<ConnState>;
    /** Reflects what device is actually connected */
    abstract device: TargetInfo | undefined;
    abstract deviceObs: Observable<TargetInfo | undefined>;
    abstract deviceSignal: Signal<TargetInfo | undefined>;
    abstract devicesSignal: Signal<Array<TargetInfo>>;
    /** Setup apps should generally not write to this directly, use TargetSelectionService instead */
    abstract selectedDevice: TargetInfo | undefined;
    abstract selectedDeviceObs: Observable<TargetInfo | undefined>;
}
